import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Municipality } from "@/components/admin/users/types";

export const useMunicipalities = () => {
  return useQuery({
    queryKey: ['municipalities'],
    queryFn: async (): Promise<Municipality[]> => {
      const { data, error } = await supabase
        .from('municipalities')
        .select('*')
        .order('name');
      
      if (error) throw error;
      
      return (data || []).map(item => ({
        ...item,
        contact_email: item.contact_email || null,
        logo_url: item.logo_url || null,
        settings: typeof item.settings === 'string' 
          ? JSON.parse(item.settings) 
          : (item.settings as Record<string, any>) || {}
      }));
    },
  });
};
